import { zodResolver } from '@hookform/resolvers/zod';
import { t } from 'i18next';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

const TRANS_KEY = 'companyDetailsGeneral:COMPANY_SITES.SITE_FORM.FORM_SCHEMA';

const formSchema = z.object({
  address: z.object({
    street: z.string().min(1, { message: t(`${TRANS_KEY}.STREET_REQUIRED`) }),
    addition: z.string(),
    zip: z.string().min(1, { message: t(`${TRANS_KEY}.ZIP_REQUIRED`) }),
    city: z.string().min(1, { message: t(`${TRANS_KEY}.CITY_REQUIRED`) }),
    country: z.string().min(1, { message: t(`${TRANS_KEY}.COUNTRY_REQUIRED`) }),
  }),
  contact: z.object({
    phone: z.string(),
    email: z
      .string()
      .trim()
      .email({ message: t(`${TRANS_KEY}.EMAIL_INVALID`) })
      .or(z.literal('')),
    fax: z.string(),
  }),
});

export type AddCompanySiteFormSchemaType = z.infer<typeof formSchema>;

const defaultValues: AddCompanySiteFormSchemaType = {
  address: {
    street: '',
    addition: '',
    zip: '',
    city: '',
    country: '',
  },
  contact: {
    phone: '',
    email: '',
    fax: '',
  },
};

type UseAddCompanySiteFormReturnType = UseFormReturn<AddCompanySiteFormSchemaType>;

export const useAddCompanySiteForm = (): UseAddCompanySiteFormReturnType =>
  useForm<AddCompanySiteFormSchemaType>({
    defaultValues,
    resolver: zodResolver(formSchema),
  });
